export const hasExceleRATEV1OnlyProduct = (productType?: ProductType) => {
	return productType === "ExceleRATEV1";
};

export const hasExceleRATEV2OnlyProduct = (productType?: ProductType) => {
	return productType === "ExceleRATEV2";
};

export const hasAnyExceleRATEProduct = (productType?: ProductType) => {
	return (
		productType === "ExceleRATEV1" ||
		productType === "ExceleRATEV2"
	);
};

export const hasDriveABLEProduct = (productType?: ProductType) => {
	return productType === "DriveABLE";
};

export const hasAnyProduct = (productType?: ProductType) => {
	return hasAnyExceleRATEProduct(productType) || hasDriveABLEProduct(productType);
};

export const OnroadText = (productType?: ProductType) => {
	if (hasAnyExceleRATEProduct(productType)) {
		return "CORE";
	} else if (hasDriveABLEProduct(productType)) {
		return "DORE";
	}

	return null;
};

export const CognitiveText = (productType?: ProductType) => {
	if (hasAnyExceleRATEProduct(productType)) {
		return "Vitals";
	} else if (hasDriveABLEProduct(productType)) {
		return "DCAT";
	}

	return null;
};